import { RedoBaseModal } from "@redotech/redo-web/arbiter-components/modal/redo-base-modal";
import {
  RedoModalFooter,
  RedoModalHeader,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { OnboardingProps } from "../common";
import mcpAgentsGlobeUrl from "./mcp-announcement-assets/mcp-agents-globe.jpg?url";
import * as styles from "./mcp-announcement-modal.module.css";

const MCP_DOCS_URL = "https://developers.redo.com/docs/mcp-server/setup";

const heroImageProps = { alt: "", src: mcpAgentsGlobeUrl };

export const McpAnnouncementModal = memo(function McpAnnouncementModal({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  const handleSetUp = () => {
    window.open(MCP_DOCS_URL, "_blank", "noopener,noreferrer");
    handleComplete();
  };

  return (
    <RedoBaseModal
      darkMode
      isOpen
      onModalCloseRequested={handleDismiss}
      otherClasses={[styles.modal]}
    >
      <Flex pt="3xl" px="3xl">
        <Flex
          {...heroImageProps}
          aria-hidden
          as="img"
          borderRadius="sm"
          w="full"
        />
      </Flex>
      <RedoModalHeader
        cancelClicked={handleDismiss}
        subtitle={
          <>
            You can now manage returns, look up order details, update statuses,
            process items, and message the Redo support AI, all from your
            preferred AI assistant.
            <br />
            <br />
            The server is compatible with any MCP-compatible client, including
            Claude, ChatGPT, Manus, Cursor, VS Code (GitHub Copilot), Windsurf,
            and Codex.
          </>
        }
        title="Try out the Redo MCP with your AI agents."
      />
      <RedoModalFooter
        primaryButton={{
          onClick: handleSetUp,
          size: "sm",
          text: "Set up the MCP",
          theme: "action",
        }}
        secondaryButton={{
          onClick: handleDismiss,
          size: "sm",
          text: "Dismiss",
        }}
      />
    </RedoBaseModal>
  );
});
